import api from './api'
import productItemRequestBody from '@/lib/products/productItemRequestBody'
import vimeoFactory from '@/lib/vimeoFactory'

function list(productId) {
  return api.get(`/admin/products/${productId}/items`)
}

function listAll(params) {
  return api.get('/admin/product-items', { params })
}

async function create(productItem, product, vimeoParams) {
  const vimeo = vimeoFactory(vimeoParams)
  const { id, productType } = product
  productItem = await productItemRequestBody.create(
    productItem,
    productType,
    vimeo,
  )

  return api.post(`/admin/products/${id}/items`, productItem)
}

async function createInBatch(productItems, product, vimeoParams) {
  const vimeo = vimeoFactory(vimeoParams)
  const { id, productType } = product
  for (const productItem of productItems) {
    productItem = await productItemRequestBody.create(
      productItem,
      productType,
      vimeo,
    )
  }

  return api.post(`/admin/products/${id}/items/batch`, productItems)
}

function destroy(productId, itemId) {
  return api.delete(`/admin/products/${productId}/items/${itemId}`)
}

async function update(productItem, product, vimeoParams) {
  const vimeo = vimeoFactory(vimeoParams)
  const { id, productType } = product
  const body = await productItemRequestBody.update(
    productItem,
    productType,
    vimeo,
  )
  return api.patch(`/admin/products/${id}/items/${productItem.id}`, body)
}

export default {
  list,
  listAll,
  create,
  createInBatch,
  destroy,
  update,
}
